import React from 'react';

const faqs = [
  {
    question: "What makes a good superhero team name?",
    answer: "A good superhero team name should be memorable, reflect your team's powers and mission, and resonate with both team members and the public. Consider incorporating elements like your team's primary abilities, cosmic/urban scope, or unifying purpose."
  },
  {
    question: "How do you create a unique superhero team name?",
    answer: "To create a unique superhero team name, combine elements like power themes (cosmic, mystic, tech), team values, and distinctive characteristics. Our generator helps by combining these elements with superhero-specific terms and popular naming patterns."
  },
  {
    question: "What are popular themes for superhero team names?",
    answer: "Popular themes include cosmic forces (Quantum Guardians, Stellar Force), urban protectors (Metro Knights, Night Watch), mystical orders (Arcane Circle, Mystic Vanguard), and tech-based teams (Cyber Division, Neon Protocol)."
  },
  {
    question: "Should my superhero team name be serious or creative?",
    answer: "This depends on your team's theme and mission. Cosmic and mystical teams often choose more serious names, while street-level teams might opt for more creative or edgy names. Consider your target audience and the type of threats you'll face."
  },
  {
    question: "Can I use my generated team name commercially?",
    answer: "Yes, the names generated are free to use. However, we recommend checking for existing trademarks if you plan to use the name commercially, especially for comics, games, or merchandise."
  },
  {
    question: "How often are new names added to the generator?",
    answer: "Our AI system continuously learns from current superhero trends and user preferences to expand its name generation capabilities, ensuring fresh and relevant suggestions."
  }
];

export default function SuperheroFAQ() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
          Superhero Team Names FAQ
        </h2>
        
        <div className="space-y-8">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-violet-50 p-6 rounded-lg transform transition-all duration-300 hover:scale-[1.02]">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                {faq.question}
              </h3>
              <p className="text-gray-600">{faq.answer}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center text-sm text-violet-600">
          <p>Don't see your question? Contact our support team for more information.</p>
        </div>
      </div>
    </section>
  );
}